module.exports = "<div id=\"legal\" [innerHTML]=\"legalResult | safeHtml\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/legals/legals.component.html
// module id = 511
// module chunks = 0